import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { environment } from "../utils/Environment";
import {
  Animations,
  AnimationRegisterFormData,
  SingleAnimation,
  AnimationRegisterResponse,
} from "../utils/Interface";
import qs from "qs";
import { RootState } from "../store/GlobalStore";
const AnimationsAPI = createApi({
  reducerPath: "AnimationsAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.api_url as string}animation`,
    prepareHeaders: (headers, { getState }) => {
      //headers.set('Content-Type', 'application/json')
      const token = (getState() as RootState).Auth.jwt;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (build) => ({
    getAllAnimations: build.query<Animations, void>({
      query: () => ({
        url: "/all",
        method: "GET",
      }),
    }),
    getAnimationById: build.query<SingleAnimation, number>({
      query: (id) => `/findOne/${id}`,
    }),
    // Query pour récupérer les incidents de l'utilisateur
    getUserIncomingAnimations: build.query<SingleAnimation[], number>({
      query: (id) => `/allUserIncomingAnimations/${id}`,
    }),
    getUserPastAnimations: build.query<SingleAnimation[], number>({
      query: (id) => `/allUserPastAnimations/${id}`,
    }),
    unsubscribe: build.mutation<
      { message: string; status: string },
      { id: number; userId: number }
    >({
      query: (data: { id: number; userId: number }) => ({
        url: "/unsubscribe",
        method: "POST",
        body: data,
      }),
    }),
    update: build.mutation<
      AnimationRegisterResponse,
      AnimationRegisterFormData
    >({
      query: (data: AnimationRegisterFormData) => ({
        url: "/update",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export default AnimationsAPI;
export const {
  useGetAllAnimationsQuery,
  useGetAnimationByIdQuery,
  useUpdateMutation,
  useGetUserIncomingAnimationsQuery,
  useGetUserPastAnimationsQuery,
  useUnsubscribeMutation,
} = AnimationsAPI;
